function initChanges() {
  const navButtons = Array.from(
    document.querySelectorAll(".collections-nav .btn")
  );

  navButtons.forEach((el, i) => {
    el.addEventListener("click", () => {
      const targetId = `${el.id.slice(0, -4)}-body`;
      const target = document.querySelector(`#${targetId} .collection-heading`);
      if (target) {
        const targetY = target.getBoundingClientRect().top - 100;
        window.scrollTo({
          top: targetY,
          left: 0,
          behavior: "smooth"
        });
        // target.scrollIntoView({
        //   behavior: "smooth"
        // });
      }
    });
  });
}

$(initChanges);
